export default __webpack_public_path__ + "static/media/river.3066a52e.svg";